module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2l"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "pt01ch02"
    }
  }, [_vm._v("chapter two")])]), _c('a', {
    attrs: {
      "id": "pt01ch02"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I’m … Cupid?” I squirmed in my seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed hard for several seconds. “What? No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sagged in relief—I "), _c('em', [_vm._v("had")]), _vm._v(" misunderstood her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not Cupid. You’re "), _c('em', [_vm._v("a")]), _vm._v(" cupid. There’s more than one of us, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, okay, then.” I stood before she could do something else crazy, like carve my name on her hand with a ballpoint pen. “It’s been really nice meeting you, but I should go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet squinted at me, then stood, as well. “You’re a skeptic. That’s okay—almost all new hires are. Follow me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pt01ch02"
    }
  }, [_vm._v("She paced across her office and opened the door, hurrying into the hallway. Did she really expect me to follow her? This was my perfect ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("chance to escape. I flung my coat on, struggling to slip my arms through the armholes as fast as I could. After snatching my purse from underneath the seat, I stepped outside of her office, then paused.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What if she was telling the truth? What if she really could prove to me I was a cupid? Or, more likely, what if she was loony but harmless, and I was missing out on the second half of a really great story to tell Andy and Maya? Before I realized what I was doing, I found myself heading down the hallway too, following the "), _c('em', [_vm._v("click-clack")]), _vm._v(" of her heels and trying to keep up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hoped I wasn’t walking blindly into my own death. Mom would be so pissed if I did something dumb like that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We hoofed it to the end of the hall and swung a left, going into a windowless room. Janet closed the door behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take a look around,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The glint of gold caught my eye immediately. There had to be millions of dollars’ worth of antique weaponry here—namely, bows and arrows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet picked out one bow and arrow and, quicker than the blink of an eye, pointed the arrow at me, firing it right into my chest.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Aaaaaaaah!” Squeezing my eyes shut, I touched my tingling chest and looked down. No arrow sticking out of my heart. Not ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("even a hole. The arrow had disappeared. “What the—?” I choked back the fearful sob building in my throat. “That’s not funny. How’d you …?”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She offered me a chagrined smile. “Sorry, but that’s quite possibly the most effective way to show you. Magical arrows. They disappear when they hit their target. I told you, it’s real.” She hung the bow back on the wall. “Oh, and don’t worry. You won’t be falling in love. A matching arrow also has to be fired at someone else for the love spell to work. It’s kind of like completing the electrical love circuit. That weird tingle you’re feeling should wear off in an hour or so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All I could do was gape as Janet led me out of the room and shut off the light, then locked the door behind us. We headed back to her office, me much more somber than before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How was this even possible? How could she fire an arrow at me and have it disappear? I’d seen her shoot me with my own two eyes. But nothing had hit. I touched my chest again, the tingle reminding me I hadn’t imagined things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seemed like there was no way to rationalize the incident other than to realize maybe it was true. I was Cupid. No, wait, "), _c('em', [_vm._v("a")]), _vm._v(" cupid.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("About a billion questions flew into my head. How long had Janet been a cupid? How was she chosen? Was the knowledge just ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("handed down from one cupid to the next? How did this all get started in the first place?")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, it hit me: This had to be the coolest thing ever to happen to me. Even better than when I won tickets from a radio station to see Panic! At The Disco in concert—from the front row, thank you very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yeah, this crushed that little triumph right into the dust.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I get wings?” I asked. If so, I hoped I got to pick out a pair of pretty ones. Maybe a nice sage green or pale purple. Or maybe she’d touch my back and they’d sprout out of my spine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shivered at the odd thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet snorted. “I wish. Unfortunately, that’s a myth. Cupids can’t fly. They’re just imbued with magical properties for matchmaking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Magic. It couldn’t exist … could it? My tingly chest taunted me with the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sudden thrill of excitement shot through me. Oh my God, I couldn’t wait to tell every—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope,” Janet said, sitting back in her executive chair. She chuckled. “I can read your face like a book. Looks like it’s time to go over the rules.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“Okay.” So being a cupid came with rules, just like everything ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("else. I guess it made sense—you wouldn’t want employees going crazy all over the place and hooking up people and chickens, or anything else weird like that.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rule number one. No one can know you’re a cupid. Not your mom, not your best friend, not anyone. Sorry, but it compromises our anonymity. It’s in the contract you signed, so don’t even think about admitting it to anyone outside the company, ever, or else … well, let’s just say don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded in agreement. “Okay. I’ll definitely keep my mouth shut.” It would be hard, because I knew me. I’d want to spill the beans to Andy and Maya. But I wasn’t about to double-cross a woman with magic arrows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Weird. My friends and I never had any big secrets from each other. I hoped this wouldn’t cause any issues. I’d have to come up with something to tell them about my job that wouldn’t cause more questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet glanced at the PDA in my hand. “Oh, and don’t lose your LoveLine 3000 or show anyone what’s on it. If someone else tries to open it, it’ll have only your school schedule, nothing else. We installed a custom security system, just to cloak the data.” She smirked proudly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Geez. This stuff was no joke. “I’ll keep it close to me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Janet nodded in approval. “Good. Now, rule number two. Only match your target to one other person at a time, making sure all matches meet the minimum-compatibility requirements of at least three common interests—but the more commonalities, the better. One pairing at a time, and if the love match doesn’t last after the magic wears off in two weeks, you can try pairing the target with someone else.”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.” I took a mental note to write all of these rules down later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And last, rule number three. While you remain in our employment, you’re not allowed to matchmake yourself. Sorry, it’s a conflict of interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, crap. My dreams of Derek and me growing old together and holding hands on a rickety porch swing flushed down the drain right before my eyes. Because without a little magic, that was never going to happen. I sighed deeply. “All right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great.” Janet beamed, her mauve lipstick perfectly framing bright white teeth. “You are required to make at least one match per week, but the more matches you make, the better chance you’ll have of creating lasting matches. Your minimum quota is one lasting match a month.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Only one a month? This was going to be a piece of cake. “Okay, so how will I know if it’s a lasting match?”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lasting love matches keep going after the magic wears off in two weeks. We offer bonuses for those, so that’s where the real money is. It’s in your best interest, then, to pair up suitable people from the start.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janet opened a drawer in her desk and rummaged through it. “Be sure to read your instruction guide before attempting to create a compatibility chart or client profile. Your LoveLine 3000 has the capacity to store thousands of profiles, so start doing some investigatory work, and match well. But, most importantly, trust your gut. Aha, here we go.” She pulled out a thick pamphlet and gave it to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is the guide on how to use the PDA to matchmake,” she continued. “Basically, you’ll send an e-mail to the target, and carboncopy the compatible love interest. When they open the e-mail, it’ll appear blank, but "), _c('em', [_vm._v("Bam")]), _vm._v("!” She wiggled her fingers in the air. “Love at first byte. Get it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I forced a laugh. “Yeah, I get it.” Sounded easy enough. I could totally do this.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Janet handed me her business card. “Call me if you get into trouble. And take it slow until you feel comfortable. "), _c('em', [_vm._v("Read the instruction guide")]), _vm._v("—it’ll help.” She smiled. “Any other questions?”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I scrunched up my face, thinking. “Actually, yeah. If customers aren’t paying for us to matchmake them, how does Cupid’s Hollow make any money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed. “We get sponsorship from companies that most benefit from love matches—the floral industry, the greeting card companies, and so on. They fund us, and we fund them. It works out nicely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sneaky. I never would have thought. “Makes sense, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Janet stood. “Okay. Well, if there aren’t any other questions, go out there and make some matches!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("After third period the next day, I tossed my biology book and matchmaking instruction guide into my locker, grabbed my bagged lunch, and slammed the locker door, trying my best not to feel guilty for once again ditching the required cupid reading. I still hadn’t gotten past the first few pages of the manual, which was littered with snoozeville statistics and compatibility rules … and about a billion teeny, tiny charts.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("I consider myself a pretty smart person, but the material went right over my head. Did Janet really expect me to get all this stuff?")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indentf"
  }, [_vm._v("The highest quotient of compatibility cofactors increases optimal relationship longevity, give or take a 3 percent margin of error based on certain established external parameters, blah blah blah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that was just on page one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After spending two hours last night reading the same few paragraphs over and over, I’d finally just decided to forge my own matchmaking path as best I could. I’d work on making minimum-compatibility matches for people I didn’t know well and do in-depth matches for closer acquaintances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This would increase my overall chances of a lasting match and save on research time, to boot. I mentally patted myself on the back for coming up with this brilliant strategy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("I whipped out my PDA and leaned back into the corner of an edge locker and a wall, scrolling through the profiles I’d been working on that morning. I’d never have expected how much pressure I would feel to make my matches good ones. This was serious stuff. ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I’d spent all morning in between classes scouring the halls before picking my first target: Britney Nelson, a new sophomore at our school, who didn’t have a lot of friends yet. However, she was cute and seemed pretty nice. I figured it shouldn’t be too hard to find her a date, especially with the help of some cupid magic.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew who Britney was because of gym class, but we weren’t close friends, so it made her the perfect choice for my first “cast the net wide” match. I could test out my cupid powers on her without being biased. I needed total objectivity to try this stuff out.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("From scrutinizing her in the hall and oh so subtly peeking in her locker while she was moving stuff in and out, I’d already figured out a few key things to start her profile:")]), _vm._v(" "), _c('p', {
    staticClass: "indentk1"
  }, [_vm._v("Name: Britney Nelson")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Age: 16ish?")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Pets: Dog, as evidenced by short, wiry hairs on her black pants. Either that, or has really hairy legs. I choose to go with the first option.")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Interests: Robert Pattinson—his picture’s plastered all over locker. Also loves the color pink.")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Style: Girly, but casual")])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("By examining the evidence, I’d come to the conclusion that Britney’s a girl who needs a sensitive guy, one who will appreciate her femininity.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, to find a match for her. Eyes still on my PDA, I stepped into the line of hallway traffic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A hard shoulder slammed into my back, and my lunch flew out of my hands. A strong, tanned hand darted out, grabbing the bag just before it hit the floor. Luckily, I kept my grip on the cupid device. Janet would so not be thrilled if I broke it on my very first day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” a deep voice behind me said. “Are you okay? I didn’t see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With fumbling fingers, I pocketed the PDA, then turned around to gaze up into piercing green eyes. Derek’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I—I, yes, I’m fine. Thanks.” A slow burn crawled up my throat and across my cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He frowned, a crease between his dark blond eyebrows. “You’re … Andy, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bit back a sigh, trying not to rub my sore shoulder. “No, I’m Felicity. Andy’s friend.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("He nodded, giving me a wry grin. “Oh, sorry. I always see you ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("two together. I’m easily confused, ya know. Football and all that—probably knocked some brain cells out.” He paused. “Aren’t you in art class with me too? I never hear you talk in there.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d noticed me? I perked up. “Yup, that’s me. Quiet as a mouse.” And übercliché, too. "), _c('em', [_vm._v("Ugh, why do I say these stupid things?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Derek.” He handed me my bag with a smile. “Okay, see you later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Bye.” I waved at his retreating back. Oh my God, I couldn’t wait to tell Andy and Maya.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In the cafeteria, I settled at my regular table beside Andy and Maya, unwrapped my turkey sandwich, and tried to refocus. Okay, back to business. I needed to match Britney up with someone. But who?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The question stuck with me throughout lunch, though I tried to act like everything was normal. Andy, in between bites of pizza, talked to me and Maya about some jerk in her homeroom who broke up with his girlfriend by having his friend dump her. So not cool. But even though I nodded and rolled my eyes and said “what a loser” at all the right parts of the story, I was only half listening. My brain was focused on cupid business.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("I was tempted to ask Andy and Maya who Britney should ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("date, or to pry them for info that I could add to her profile, but Janet’s rules kind of scared me. I was better off trying to figure this out myself.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I finished my sandwich and balled up the trash, proud of myself for not breaking down and getting a slice of pepperoni-laden pizza. As tasty as Andy’s lunch had looked, I didn’t need a greasy skin breakout, since junior prom was coming up soon. Of course, I didn’t have a date, but neither did Andy or Maya, so I figured we could always go as a group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the girls kept chatting, I wandered over to the trash cans to pitch my garbage. My heart fluttered when I thought about how romantic it would be to dance with Derek at prom, even just once. I’d be sitting at the table with Maya and Andy, telling them a funny and clever story, and he’d walk up to me, a shy smile on his face, and say—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, don’t throw that can away. You can recycle it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I jumped, startled out of my daydream. “Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matthew Cornwall, a guy from my biology class, pointed to the empty soda can in my hand. “There’s a recycling bin by the front doors.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, right.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("He smiled. “Thanks. Sorry to scare you. Just trying to do my part, you know.” He walked away, waving hi to another guy and starting up some conversation.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hm. Matthew seemed pretty decent—he knew how to apologize, after all. Plus, he wasn’t a total jerk in class and usually had smart commentary on the lessons … and caring for the environment was a good quality too. Maybe he’d make a good match for Britney.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I got back to the lunch table, I told the girls I’d meet them after school as usual, then headed over to where Matthew was talking and squatted at a nearby table, trying to look casual while eavesdropping like mad.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("I turned on the PDA and created a new profile.")]), _vm._v(" "), _c('p', {
    staticClass: "indentk1a"
  }, [_vm._v("Name: Matthew Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Age: 17")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Pets: Has a bird. Remember him talking about it in biology.")]), _vm._v(" "), _c('p', {
    staticClass: "indentk"
  }, [_vm._v("Interests: Recycling, obviously")]), _vm._v(" "), _c('p', {
    staticClass: "indentkb"
  }, [_vm._v("Style: Tree-hugger")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("But what else?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("I leaned my ear in his direction as he talked to the other guy. ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("For a few minutes they did nothing but go on and on about school sports. I added that to his interests list and tried not to die of boredom as they argued the finer points of one of our basketball players’ stats. Then, a perfect tidbit came up.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, did you catch the opening band at Peabody’s last Friday? They were awesome.” Matthew grabbed a folded piece of paper out of his messenger bag and handed it to his friend. “Here’s their flyer. My cousin knows the lead singer. They’re playing again next month. You should go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks, I’ll try,” the guy replied, stuffing the flyer in his back pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aha, so Matthew likes indie music. Peabody’s is well-known in downtown Cleveland for featuring small local bands, and it was obvious from the enthusiasm in Matthew’s voice that he enjoys going there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indie rockers are sensitive, always crying about something or another, aren’t they? I went to Britney’s profile, looking over what I’d found about her. Both she and Matthew have animals, and it’s a well-known fact that pet people tend to like other pet people. And I was guessing that they’re both the sensitive type. But what would be my third minimum trait?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Hm. They both attended Greenville High, so that could count as one common interest, couldn’t it? Well, I’d make it count. Besides, after they got together, I was sure they’d find lots more in common.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Yup, it was time to do a little matchmaking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Using the PDA, I created a blank e-mail to Britney and carbon-copied Matt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My stomach flipped in nervousness. Before I could talk myself out of it, I hit send.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first love match—signed, sealed, and e-mailed.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58549d2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pt01ch02.vue
// module id = 78
// module chunks = 0